import React from "react";
import { Box, Button } from "@mui/material";
import LinkOffIcon from "@mui/icons-material/LinkOff";
import { alpha } from "@mui/material/styles";
import { GRAY_COLOR_DARK } from "../../../../../constants/colors";

/**
 * グループに対する操作ボタン
 */
export default function ProjectGroupActions({
  groupId,
  processing,
  onUngroup,
}) {
  return (
    <Box
      sx={{
        display: "flex",
        gap: 1,
        alignItems: "center",
        flexWrap: "wrap",
      }}
    >
      {/* グループ解除ボタン */}
      <Button
        size="small"
        variant="outlined"
        startIcon={<LinkOffIcon />}
        onClick={() => onUngroup?.(groupId)}
        disabled={processing}
        sx={{
          borderColor: alpha(GRAY_COLOR_DARK, 0.35),
          color: GRAY_COLOR_DARK,
          fontWeight: 700,
          borderRadius: 999,
          px: 1.5,
          bgcolor: "#fff",

          "&:hover": {
            borderColor: GRAY_COLOR_DARK,
            bgcolor: alpha(GRAY_COLOR_DARK, 0.06),
          },
        }}
      >
        グループを解除
      </Button>
    </Box>
  );
}
